export const SIGN_IN_BEGIN = "SIGN_IN_BEGIN"
export const SIGN_IN_SUCCESS = "SIGN_IN_SUCCESS"
export const SIGN_IN_FAILURE = "SIGN_IN_FAILURE"

export const SIGN_OUT_BEGIN = "SIGN_OUT_BEGIN"
export const SIGN_OUT_SUCCESS = "SIGN_OUT_SUCCESS"
export const SIGN_OUT_FAILURE = "SIGN_OUT_FAILURE"

export const SIGN_UP_BEGIN = "SIGN_UP_BEGIN"
export const SIGN_UP_SUCCESS = "SIGN_UP_SUCCESS"
export const SIGN_UP_FAILURE = "SIGN_UP_FAILURE"

export const SAVE_USER_DATA_BEGIN = "SAVE_USER_DATA_BEGIN"
export const SAVE_USER_DATA_SUCCESS = "SAVE_USER_DATA_SUCCESS"
export const SAVE_USER_DATA_FAILURE = "SAVE_USER_DATA_FAILURE"

export const SIGN_UP_GUARDIAN_BEGIN = "SIGN_UP_GUARDIAN_BEGIN"
export const SIGN_UP_GUARDIAN_SUCCESS = "SIGN_UP_GUARDIAN_SUCCESS"
export const SIGN_UP_GUARDIAN_FAILURE = "SIGN_UP_GUARDIAN_FAILURE"

export const SIGN_UP_GUARDIAN_INFO_BEGIN = "SIGN_UP_GUARDIAN_INFO_BEGIN"
export const SIGN_UP_GUARDIAN_INFO_SUCCESS = "SIGN_UP_GUARDIAN_INFO_SUCCESS"
export const SIGN_UP_GUARDIAN_INFO_FAILURE = "SIGN_UP_GUARDIAN_INFO_FAILURE"

export const SIGN_IN_GUARDIAN_BEGIN = "SIGN_IN_GUARDIAN_BEGIN"
export const SIGN_IN_GUARDIAN_SUCCESS = "SIGN_IN_GUARDIAN_SUCCESS"
export const SIGN_IN_GUARDIAN_FAILURE = "SIGN_IN_GUARDIAN_FAILURE"

export const SignInBegin = () => ({
  type: SIGN_IN_BEGIN
})

export const SignInSuccess = user => ({
  type: SIGN_IN_SUCCESS,
  payload: { user }
})

export const SignIsFailure = error => ({
  type: SIGN_IN_FAILURE,
  payload: { error }
})

export const SignOutBegin = () => ({
  type: SIGN_OUT_BEGIN
})

export const SignOutSuccess = () => ({
  type: SIGN_OUT_SUCCESS
})

export const SignOutFailure = () => ({
  type: SIGN_UP_FAILURE
})

export const SignUpBegin = () => ({
  type: SIGN_UP_BEGIN
})

export const SignUpSuccess = () => ({
  type: SIGN_UP_SUCCESS
})

export const SignUpFailure = () => ({
  type: SIGN_UP_FAILURE
})

export const SaveUserDataBegin = () => ({
  type: SAVE_USER_DATA_BEGIN
})

export const SaveUserDataSuccess = user => ({
  type: SAVE_USER_DATA_SUCCESS,
  payload: { user }
})

export const SaveUserDataFailure = error => ({
  type: SAVE_USER_DATA_FAILURE,
  payload: { error }
})

export const SignUpGuardianBegin = () => ({
  type: SIGN_UP_GUARDIAN_BEGIN
})

export const SignUpGuardianSuccess = () => ({
  type: SIGN_UP_GUARDIAN_SUCCESS
})

export const SignUpGuardianFailure = () => ({
  type: SIGN_UP_GUARDIAN_FAILURE
})

export const SignUpGuardianInfoBegin = () => ({
  type: SIGN_UP_GUARDIAN_INFO_BEGIN
})

export const SignUpGuardianInfoSuccess = data => ({
  type: SIGN_UP_GUARDIAN_INFO_SUCCESS,
  payload: { data }
})

export const SignUpGuardianInfoFailure = () => ({
  type: SIGN_UP_GUARDIAN_INFO_FAILURE
})

export const SignInGuardianBegin = () => ({
  type: SIGN_IN_GUARDIAN_BEGIN
})

export const SignInGuardianSuccess = user => ({
  type: SIGN_IN_GUARDIAN_SUCCESS,
  payload: { user }
})

export const SignInGuardianFailure = error => ({
  type: SIGN_IN_GUARDIAN_FAILURE,
  payload: { error }
})
